export const environment = {
  production: true
};

export const APPLICATION_INSIGHTS_CONNECTION_STRING = 'InstrumentationKey=00000000-0000-0000-0000-000000000004;IngestionEndpoint=https://telemetry.winstonfinancial.com/';
